export default "__VITE_ASSET__CqIL9g79__"